import { Grid } from '@mui/material';
import { useLocation } from 'react-router';

import { useGlobalDrawer } from 'common/hooks/useGlobalDrawer';
import { IGlobalDrawerType } from 'common/types';
import {
    IFeaturedArticleCardFragment,
    IOfferEventCardFragment,
    IOfferEventType,
    ITrainingListCardFragment,
    ITrainingRoleFilter,
} from 'graphql/types';
import { FeaturedArticleCard } from 'library/components/FeaturedArticleCard';
import { OfferEventCard } from 'offer/components/OfferEventCard';
import { TrainingCard } from 'training/components/TrainingCard';

interface IProps {
    featuredArticles?: IFeaturedArticleCardFragment[];
    offerEvents: IOfferEventCardFragment[];
    trainingRoleFilter: ITrainingRoleFilter;
    trainings: ITrainingListCardFragment[];
}

export const HomePageResults = ({
    featuredArticles,
    offerEvents,
    trainingRoleFilter,
    trainings,
}: IProps) => {
    const location = useLocation();
    const { openGlobalDrawer } = useGlobalDrawer();

    const meetingWebinars = offerEvents.filter(
        (event) =>
            event.type === IOfferEventType.Meeting ||
            event.type === IOfferEventType.Webinar
    );
    const elearningCourse = offerEvents.filter(
        (event) =>
            event.type === IOfferEventType.Elearning ||
            event.type === IOfferEventType.Course ||
            event.type === IOfferEventType.Scorm
    );
    const offerEventTrainings = offerEvents.filter(
        (event) => event.type === IOfferEventType.Training
    );

    const handleClickOfferEvent = (offerEvent: IOfferEventCardFragment) => {
        const { id, offerId, hasDetailPage } = offerEvent;

        openGlobalDrawer(
            {
                type: hasDetailPage
                    ? IGlobalDrawerType.OfferEvent
                    : IGlobalDrawerType.Offer,
                itemId: hasDetailPage ? id : offerId,
            },
            location
        );
    };

    return (
        <Grid container spacing={3}>
            {featuredArticles?.map((article) => (
                <Grid
                    key={article.id}
                    size={{
                        md: 4,
                        sm: 6,
                        xs: 12,
                    }}
                >
                    <FeaturedArticleCard article={article} />
                </Grid>
            ))}

            {meetingWebinars.map((offerEvent) => (
                <Grid
                    key={offerEvent.id}
                    size={{
                        md: 4,
                        sm: 6,
                        xs: 12,
                    }}
                >
                    <OfferEventCard
                        offerEvent={offerEvent}
                        onClick={handleClickOfferEvent}
                    />
                </Grid>
            ))}
            {elearningCourse.map((offerEvent) => (
                <Grid
                    key={offerEvent.id}
                    size={{
                        md: 4,
                        sm: 6,
                        xs: 12,
                    }}
                >
                    <OfferEventCard
                        offerEvent={offerEvent}
                        onClick={handleClickOfferEvent}
                    />
                </Grid>
            ))}
            {offerEventTrainings.map((offerEvent) => (
                <Grid
                    key={offerEvent.id}
                    size={{
                        md: 4,
                        sm: 6,
                        xs: 12,
                    }}
                >
                    <OfferEventCard
                        offerEvent={offerEvent}
                        onClick={handleClickOfferEvent}
                    />
                </Grid>
            ))}
            {trainings?.map((training) => (
                <Grid
                    key={training.id}
                    size={{
                        md: 4,
                        sm: 6,
                        xs: 12,
                    }}
                >
                    <TrainingCard
                        showTypeIcon
                        hideProgress={
                            trainingRoleFilter !==
                            ITrainingRoleFilter.Participant
                        }
                        hideTrainerChip={
                            trainingRoleFilter === ITrainingRoleFilter.Trainer
                        }
                        training={training}
                    />
                </Grid>
            ))}
        </Grid>
    );
};
